export function viewPortHeightToPX(vpHeight: number): string {
    return (window.screen.height * (vpHeight / 100)) + 'px';
}
